/* eslint-disable no-undef */
// remove no-js flag
$('html').removeClass('no-js');

if ($('.countValue').length > 0) {
  $('.countValue').each(function() {
    if ($(this).parents('.globalJobCountAggregation, .globalJobCountAggregationCarousel, .localJobCountAggregation').length === 0) {
      $(this).parent().addClass('globalJobCountAggregation');
    }
  });
}

$(() => {
  $(document).ready(() => {
    initMobileMenu();
    initFancybox();
    initParallax();
    initSlider();
    initSmallLayoutAnimations();
    initTeaserCourses();

    /* open modal z-index bug */
    $('.modal').each( function () {
      this.addEventListener('show.bs.modal', (event) => {
        $(event.target).parents('.frame-container').addClass('modal-open');
      });
      this.addEventListener('hide.bs.modal', (event) => {
        $(event.target).parents('.modal-open').removeClass('modal-open');
      });
    });
  });
});

// reopen cookiebot configuration
$('a[href*="#cookiebot"]').on('click', function (e) {
  let cookiebot = false;
  const href = $(this).attr('href');
  if (href === '#cookiebot') {
    cookiebot = true;
  } else {
    const url = new URL(href);
    if (url !== false) {
      if (url.hash === '#cookiebot') {
        cookiebot = true;
      }
    }
  }

  if (cookiebot === true) {
    e.preventDefault();
    if (typeof Cookiebot !== 'undefined') {
      Cookiebot.show();
    }
  }
});

$(() => {
  initAjaxForms();
});

minimizePageHeader();

// FIX wrong 100vh in iOS and android jumps when the url bar hides
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// this is than used as var inside css/less
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', (e) => {
  vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});
